import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EventLogsState } from './event-logs.reducers';

export const eventLogsState = createFeatureSelector<EventLogsState>('eventLogs');

export const eventLogsSelector = createSelector(eventLogsState, eventLogs => eventLogs.eventLogs);
